<template>
  <div class="bg-gray">
    <navigation-bar />
    <div class="container">
      <div class="row">
        <div class="col-sm-12" style="margin:20px; background:white; border-radius:10px;padding:10px">
          <h1> FAQ</h1>
          <div style="padding-bottom:20px;" v-for="(qa,idx) in qas" :key="idx">
            <h4>{{qa.question}}</h4>
            <p>{{qa.answer}}</p>
            <hr>
          </div>
          <div>
            <h3>Still Have Questions?</h3>
            <router-link to="/contact">
              <button style="margin-top:10px;" class="btn btn-primary btn-blue">Contact Us</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from './nav/NavigationBar'
import DashboardFooter from './nav/Footer'
import Utils from '../Utils/Utils'
import Navigator from '@/router/navigator'
import AccountSessionUtils from "@/components/account/AccountSessionUtils";
export default {
  name: 'Home',
  components: {
    NavigationBar,
    DashboardFooter
  },
  data () {
    return {
      nav: Navigator,
      accountUtils: AccountSessionUtils,
      qas : [
        {
          question:' Is there a fee to advertise my competition on your site?',
          answer: 'No, there is no charge to advertise your competition on Everything Cheer and Dance, but you will need to register on the site. This allows you to post your events information and make changes if needed.'
        },
        {
          question:'Is there a fee to be advertise vendor services on Everything Cheer and Dance?',
          answer:'Yes, there is a small monthly fee to advertise vendor services. For the price of a coffee you can have your business/services listed on Everything Cheer and Dance. '
        },
        {
          question:'Why is there a fee to advertise vendor services?',
          answer:`Answer: It is the goal of Everything Cheer and Dance to connect programs with quality vendors. This fee helps cover:
          1.	The expenses of creating and maintaining the website.
          2.	Maintaining a current listing of legitimate and actively operating cheer and dance vendors.
          3.	Marketing of the website to give all who are listed on Everything Cheer and Dance greater exposure.`
        },
        {
          question:'Can I make a favorites list of vendors I use so I can easily find their contact info?',
          answer:'Yes, all you need to do is register for free on the site.  You then have to option to make a favorites list. '
        },
        {
          question:'Does Everything Cheer and Dance vet vendors advertising on the website?',
          answer:'No we do not. We encourage you to ask for references, experience, and clearances of vendors that you may consider hiring. Everything Cheer and Dance does not promote, endorse, nor guarantee the quality of services of any of the vendors listed on the website. '
        },
        {
          question:' How do you add a listing?',
          answer: 'To add a listing, first you need to create an account. After that, you can click `Create Listing` in the navigation menu. You will then select your category, listing size, and enter any information for your listing.'
        },
        {
          question:' How do you remove a listing?',
          answer: 'To remove a listing, tap `My Listings` in the navigation menu at the top of the page. There you will be able to see all of your listings. You can click `Delete` to remove a free listing or `Cancel Subscription` to remove a paid listing. After canceling a paid listing, it will appear as unpaid in your listings page and will no longer be visible to the public.'
        },
      ]
    }
  },
  mounted () {
    this.accountUtils.authorize(
      userId => {
        this.store.state.currentUserId = userId;
      },
      () => {}
    );
  },
  methods: {


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.service-card{
  background: white;
  border-radius: 10px;
  height: 150px;
  overflow:hidden;
}

.orange {
  color:#FF6F5E;
}

.blue {
  color:#192965;
}

.orange-overlay {
  filter: invert(53%) sepia(34%) saturate(887%) hue-rotate(318deg) brightness(98%) contrast(109%);
}

.blue-overlay {
  filter: invert(16%) sepia(14%) saturate(6187%) hue-rotate(205deg) brightness(92%) contrast(100%);
}

p{
  padding-left:10px;
  padding-right:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/FAQ.vue